// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gCzg","largestCol":"styles_largestCol__7xBuw","smallestCol":"styles_smallestCol__TzTwv"};